<template>
  <n-layout class="blank-layout">
    <n-layout-content class="main-content">
      <slot />
    </n-layout-content>
  </n-layout>
</template>

<style>
/* .blank-layout {
  min-height: 100vh;
} */
</style>
